import { render, staticRenderFns } from "./DoctorsComponent.vue?vue&type=template&id=232b8fd1&"
import script from "./DoctorsComponent.vue?vue&type=script&lang=js&"
export * from "./DoctorsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports